




import logger from "@plat-components/utils2/_esm5/logger";
import { produce } from "immer";
import Vue from "vue";
import { createStore } from "@bilibili/rxstore";
import { uniq, xor, get, compact } from "lodash-es";
import { map, distinctUntilChanged, debounceTime } from "rxjs/operators";
import fetch from "superagent";
import toast from "@bilibili/vanilla-toast";
import { getCookie } from "@plat-components/utils2/_esm5/cookie";
import { login } from "@/utils/ensureLogin";
const isUat = location.href.indexOf("uat") > 0;

const host = isUat
  ? "https://uat-api.bilibili.com"
  : "https://api.bilibili.com";

export const followStore = createStore<{
  watcher: string[];
  map: {
    [index: string]: any;
  };
}>({
  watcher: [],
  map: {}
});

// 获取关注信息
export async function getFollowInfo(mids: string[]) {
  const res = await fetch
    .get(`${host}/x/relation/relations`)
    .query({ fids: compact(mids).join(",") })
    .withCredentials();
  const { code, message, data } = res.body;
  if (code !== 0) {
    return Promise.reject(new Error(`获取信息失败: ${message}`));
  }
  return data;
}

const refreshFollowMap = (watcher: string[]) => {
  if (watcher.length > 0) {
    getFollowInfo(watcher).then(data => {
      followStore.next(s =>
        produce(s, d => {
          d.map = data;
          return d;
        })
      );
    });
  }
};

followStore.obs
  .pipe(
    map(v => v.watcher),
    debounceTime(50),
    distinctUntilChanged((prev, next) => xor(prev, next).length === 0)
  )
  .subscribe(watcher => refreshFollowMap(watcher));

// 进行关注操作
export async function doFollow(uid: string) {
  const res = await fetch
    .post(`${host}/x/relation/modify`)
    .set("Content-Type", "application/x-www-form-urlencoded")
    .send({
      fid: uid,
      csrf: getCookie("bili_jct"),
      // eslint-disable-next-line @typescript-eslint/camelcase
      re_src: 222,
      jsonp: "jsonp",
      act: 1
    })
    .withCredentials();
  const msg = res.body.message || "关注失败，请重试";
  const code = res.body.code;

  if (code === 0) {
    setTimeout(() => {
      refreshFollowMap(followStore.getValue().watcher);
    }, 50);
    return true;
  } else {
    if (code === -101) {
      login();
      return Promise.reject(msg);
    }

    if (code === -102) {
      toast.error("被封禁用户不能关注哦！");
      return Promise.reject(msg);
    }

    toast.error(msg);
    return Promise.reject(msg);
  }
}

const pipe = (mid: string) =>
  followStore.obs.pipe(
    map(data => data.map),
    map(map => {
      const attribute = get(map, `${+mid}.attribute`);
      return attribute === 2 || attribute === 6;
    }),
    distinctUntilChanged()
  );

export default Vue.extend({
  props: ["mid", "onFollow", "cls"],
  mounted() {
    this.sync();
  },
  updated() {
    this.sync();
  },
  destroyed() {
    this.sub && this.sub.unsubscribe();
  },
  methods: {
    sync() {
      const mid = this.mid;

      if (mid) {
        followStore.next(s => {
          return produce(s, d => {
            d.watcher = uniq([...d.watcher, mid]);
            return d;
          });
        });
      }

      this.sub = pipe(mid).subscribe(v => {
        this.followed = v;
      });
    },
    handleClick() {
      if (this.followed) return;
      logger("follow_" + this.mid);
      doFollow(this.mid).then(() => {
        this.onFollow && this.onFollow();
        this.followed = true;
      });
    }
  },
  data() {
    return {
      followed: false,
      sub: null as any
    };
  }
});
